import { broadcastCookieUpdateToIframes } from './utils/iframe-broadcast.ts';

export function iframeContextReadyEventHandler() {
  broadcastCookieUpdateToIframes();
}
